import { Collapse, type CollapseOptions } from '@sg-core/src/View/Components/Atoms/Collapse';

interface CardExpandableOptions {
  i18n: {
    closeLabel: string;
  };
}

/**
 * TODO: legacy interop
 * Correctly prefix the class once the card component is migrated
 */
export class CardExpandable {
  private el: HTMLElement;
  private options: CardExpandableOptions;
  private collapsible?: Collapse;
  private observer?: ResizeObserver;
  private buttonText?: HTMLElement;
  private originalButtonText?: string;

  constructor(el: HTMLElement, options: CardExpandableOptions) {
    this.el = el;
    this.options = options;

    this.initCollapsible();
    this.observeOverflow();
  }

  private observeOverflow(): void {
    const observed = this.el.querySelector('.card-body__description');

    if (!observed) {
      return;
    }

    this.observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const [boxSize] = entry.contentBoxSize;

        if (boxSize && boxSize.blockSize < entry.target.scrollHeight) {
          entry.target.classList.add('card-body__description--clamped');
        } else {
          entry.target.classList.remove('card-body__description--clamped');
        }
      }
    });

    this.observer.observe(observed as HTMLElement);
  }

  private handleExpand = (): void => {
    if (this.buttonText) {
      this.buttonText.innerText = this.options.i18n.closeLabel;
    }
  };

  private handleCollapse = (): void => {
    if (this.buttonText && this.originalButtonText) {
      this.buttonText.innerText = this.originalButtonText;
    }
  };

  private initCollapsible(): void {
    const collapsible = this.el.querySelector('.card-body__description') as HTMLElement | null;

    if (!collapsible) {
      return;
    }

    const options: CollapseOptions = {
      minHeight: 'calc(var(--sys-typography-body-large-size) * (var(--ref-line-height-lg) * 2))',
    };

    this.collapsible = new Collapse(collapsible, options);
    this.buttonText = this.collapsible.trigger.querySelector('.phxsg-btn__text') as HTMLElement | undefined;

    if (this.buttonText) {
      this.originalButtonText = this.buttonText.innerText;

      this.collapsible.on('expand', this.handleExpand);
      this.collapsible.on('collapse', this.handleCollapse);
    }
  }

  destroy(): void {
    this.observer?.disconnect();
    this.collapsible?.destroy();

    if (this.collapsible) {
      this.collapsible.off('expand', this.handleExpand);
      this.collapsible.off('collapse', this.handleCollapse);
    }
  }
}
